import {
    getPriceFailure,
    getPriceLoading,
    getPriceSuccess,
    getPriceByIdFailure,
    getPriceByIdLoading,
    getPriceByIdSuccess,
    updatePriceSuccess,
    updatePriceLoading,
    updatePriceFailure,
    createPriceSuccess,
    createPriceLoading,
    createPriceFailure
} from "../redux/slices/priceSlice";
import { getPrices } from "@services/prices/getPrices";
import { updatePrice } from "@services/prices/updatePrice";
import { createPrice } from "@services/prices/createPrice";
import { useDispatch } from "react-redux";
import getErrorStatement from "../utils/getErrorStatement";
import { notify } from "../utils/notify";
import { getPriceById } from "@services/prices/getPriceById";

const usePrice = () => {
    const dispatch = useDispatch();

    const handleGetPrice = async (searchFilters) => {
        try {
            dispatch(getPriceLoading());
            const response = await getPrices(searchFilters);
            dispatch(getPriceSuccess(response.data));
            notify("Price details fetched successfully", "success");
        } catch (error) {
            dispatch(getPriceFailure());
            notify(getErrorStatement(error));
        }
    };

    const handleGetPriceById = async (myReferenceNumber) => {
        try {
            dispatch(getPriceByIdLoading());
            const response = await getPriceById (myReferenceNumber);
            dispatch(getPriceByIdSuccess(response.data));
        } catch (error) {
            dispatch(getPriceByIdFailure());
            notify(getErrorStatement(error));
        }
    }

    const handleUpdatePrice = async (
        priceId,
        updatedData,
        onSuccess = null
    ) => {
        try {
            dispatch(updatePriceLoading());
            const response = await updatePrice(priceId, updatedData);
            dispatch(updatePriceSuccess(response.data));
            notify("Price details updated successfully", "success");
            handleGetPriceById(updatedData?.myReferenceNumber);
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            dispatch(updatePriceFailure());
            notify(getErrorStatement(error));
        }
    };

    const handleCreatePrice = async (priceData, onSuccess = null) => {
        try {
            dispatch(updatePriceLoading());
            const response = await createPrice(priceData);
            dispatch(updatePriceSuccess(response.data));
            notify("Price details created successfully", "success");
            handleGetPrice();
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {make 
            dispatch(updatePriceFailure());
            notify(getErrorStatement(error));
        }
    }

    return {
        handleGetPrice,
        handleGetPriceById,
        handleUpdatePrice,
        handleCreatePrice
    };
}

export default usePrice;